import { useEffect, useState } from 'react'
import { supabase } from '../../supabaseClient'

import {
  widgetCardStyle,
  labelStyle,
  valueStyle,
  footerStyle,
} from '../styles/widgetStyles'

function TotalPlansWidget() {
  const [count, setCount] = useState(0)
  const [hover, setHover] = useState(false)
  

  useEffect(() => {
    const fetchCount = async () => {
      const { count, error } = await supabase
        .from('plans_test')
        .select('*', { count: 'exact', head: true })
      if (!error) setCount(count)
    }
    fetchCount()
  }, [])

  return (
    <div
      style={widgetCardStyle(hover)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div style={labelStyle}>
        📁 Total Plans
      </div>
      <div style={valueStyle}>{count}</div>
      <div style={footerStyle}>Number of uploaded insurance plans <br />
        Riq is an expert on these plans</div>  
    </div>
  )
}

export default TotalPlansWidget
